import React, { useState } from 'react';

const PreviewImage = ({ file }) => {
  return (
    <div>
      <img src={file} className='w-[8rem] h-[8rem]' alt='product' />
    </div>
  );
};

export default PreviewImage;
